import { createRef, useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Column, DateTimePicker, Label, List, Row, Select } from "../../../components";
import TextInputWithLabelInline from "../../../shared/components/input/TextInputWithLabelInline";
import * as lables from "../../../shared/util/label";
import * as appConstants from '../../../shared/util/constant';
import { CustomerLossReadDto } from "../../model/CustomerLossDto";
import './CustomerLossForm.scss';
import CustomerLossFormService from "./CustomerLossFormservice";
import { updateLookupData } from "../../customer-slice/Customer-lookup-slice";
import { CustomerLossHistoryConstant, SlicerLookUpConstant } from "../../../shared/util/constant";
import { RootState } from "../../../shared/store";
import DropDownWithLabelInline from "../../../shared/components/input/DropDownWithLabelInline";
import { SelectOption } from "../../../shared/components/input";
import Logger from "../../../shared/services/Logger";
import TextFieldWithLabelInline from "../../../shared/components/input/TextFieldWithLabelInline";
import { useConfirmationModalContext } from "../../../shared/components/ModalConfirmationContext";
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import CustomerActivityService from "../../customer-activity/CustomerActivityService";
import { options } from "@fullcalendar/core/preact";
import CustomerPolicyListService from "../../customer-policy/CustomerPolicyListService";
import { storeCustomerPolicies } from "../../customer-slice/Customer-slice";
import { CommonUtility } from "../../../Services/CommonUtility";
import { AbilityContext } from "../../../shared/abilities/AbilityContext";
import * as constant from '../../../shared/util/constant';




export interface ICustomerLossForm {
    customerId? : string;
    customerLoss : CustomerLossReadDto; 
    onCancelClick : () => void;
    onLossHistoryCreated : (customerLossDto : CustomerLossReadDto) => void;
    onLossHistoryUpdated : (customerLossDto : CustomerLossReadDto) => void;
    setIsFormSaved?: (isSaved: boolean) => void; 
}

const CustomerLossForm : React.FunctionComponent<ICustomerLossForm> = (props) => {
    const dispatch = useDispatch()
    const modalContext = useConfirmationModalContext();
    const customerLossFormService = new CustomerLossFormService();
    const {customerId, customerLoss} = props;

    const lossTypeData = useSelector((state: RootState) => state?.LookupState.lossTypeList);
    const claimStatusData = useSelector((state: RootState) => state?.LookupState.claimsStatusList);
    const userDetails = useSelector(state => state.userContextSlice);
    const customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice)
    const userName = `${userDetails?.userContext?.firstName} ${userDetails?.userContext?.lastName}`;

    const [formValidation, setFormValidation] = useState<any>({});
    const [customerLossData, setCustomerLossData] = useState<CustomerLossReadDto>({});    

    const [lossTypesList, setLossTypeList] = useState<SelectOption[]>([]);
    const [claimStatusList, setClaimStatusList] = useState<SelectOption[]>([]);
    const [listOfPolicy, setPolicyNumberList] = useState<SelectOption[]>([]);
    const customerActivityService = new CustomerActivityService();
    const companyRef = useRef(null);

    const ability = useContext(AbilityContext);
    const canUserCreateCustomerLossHistory = ability.can('create', "Customer Loss History", constant.ScreenName.CUSTOMER_LOSS_HISTORY);
    const canUserEditCustomerLossHistory = ability.can('update', "Customer Loss History", constant.ScreenName.CUSTOMER_LOSS_HISTORY);
    
   
    useEffect(() => {
        initializeComponent();
    }, [customerLoss]);

    const initializeComponent = async () => {
        let policies = [...customerpolicyDetail.policies];
        
        if (policies.length == 0) {
            const customerPolicyListService  = new CustomerPolicyListService();
            policies = await customerPolicyListService.fetchCustomerPolicyDetails(customerId);
            dispatch(storeCustomerPolicies(policies));
            customPolicyListConversion(policies);
        }
        else
        {
            customPolicyListConversion(policies);
        }
        

        if (!lossTypeData || lossTypeData.length == 0) {
            let lossTypes = await customerLossFormService.fetchLossTypes();
            dispatch(updateLookupData({data : lossTypes, type : SlicerLookUpConstant.LOSS_TYPE}));
            setLossTypeList(lossTypes);
        }
        else {
            setLossTypeList([...lossTypeData]);
        }

        if (!claimStatusData || claimStatusData.length == 0) {
            let claimsStsList = await customerLossFormService.fetchClaimStatusList();
            dispatch(updateLookupData({data : claimsStsList, type : SlicerLookUpConstant.CLAIMS_STATUS}));
            setClaimStatusList(claimsStsList);
        }
        else {
            setClaimStatusList([...claimStatusData]);
        }

        let lossDataObj : CustomerLossReadDto = null;

        if (customerLoss.id) {
            lossDataObj = {...customerLoss};
        }
        else {
            lossDataObj = {...customerLoss, changedByValue : userName};
        }

        setCustomerLossData(lossDataObj);
    };
    const customPolicyListConversion = async (policies: any) => {
        policies?.sort((a, b) => new Date(b.polEffDate).getTime() - new Date(a.polEffDate).getTime());
        let formattedPolicies:any = [];
        policies?.forEach((values) => {
            formattedPolicies.push({
                label: CommonUtility.formatPolicy(
                values.policyNumber,
                values.polEffDate,
                values.polExpDate
              ),

                value: CommonUtility.formatPolicy(
                    values.policyNumber,
                    values.polEffDate,
                    values.polExpDate
                ),
            });
        });
        // customerActivityService.getPoliciesForCustomer(customerId) //Above code should be replaced with this in future
        setPolicyNumberList(formattedPolicies);
    }
    const defaultColumnLg = 6
    const defaultColumnMd = 6

    const columnFullLg = 12
    const columnFullMd = 12

    const isEditable = true;

    const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {
    if (propName == 'policyNumber') {
        // Add safety check - only process if value exists
        if (value && value.toString().trim().length > 0) {
            let splitData = value.toString().split(':')[1].split('-');
            setCustomerLossData({
                ...customerLossData,
                ['policyNumber']: value.toString(), ['policyEffDate']: new Date(splitData[0]), ['policyExpDate']: new Date(splitData[1])
            });
        } else {
            // Handle empty/null value (backspace case)
            setCustomerLossData({
                ...customerLossData,
                ['policyNumber']: '',
                ['policyEffDate']: null,
                ['policyExpDate']: null
            });
        }
    }
    else {
        setCustomerLossData({
            ...customerLossData,
            [propName]: value,
        });
    }
    props.setIsFormSaved(false)
}
    const onCancelClick = async () => {
        const result = await modalContext.showConfirmation(CustomerLossHistoryConstant.ARE_YOU_SURE_TO_EXIST)
        if(result){
            props.onCancelClick();
        }
    }

    const onSaveClick = async () => {
        let validationError = customerLossFormService.validateCustomerLossData(customerLossData);
        setFormValidation(validationError);
            if (Object.keys(validationError).length > 0) {
                toast.warn(CustomerLossHistoryConstant.FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }

        try {
            customerLossData.policyNumber = customerLossData.policyNumber.split(':')[0].trim();
            let requestDto = customerLossFormService.getCustomerLossRequestDto(customerLossData, customerId);
            let data = await customerLossFormService.saveCustomerLossData(requestDto);
            if (data) {
                toast.success(CustomerLossHistoryConstant.SAVE_CUSTOMER_LOSS_SUCCESS, {
                    position: toast.POSITION.TOP_RIGHT
                });

                if (requestDto.id) {
                    props.onLossHistoryUpdated(data);
                }
                else {
                    props.onLossHistoryCreated(data);
                }
            }
            else {
                toast.error(CustomerLossHistoryConstant.SAVE_CUSTOMER_LOSS_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            props.setIsFormSaved(true)
        }
        catch(ex) {
            Logger.logError(CustomerLossHistoryConstant.SAVE_CUSTOMER_LOSS_ERROR_MESSAGE, ex);
            props.setIsFormSaved(false)
            if (ex.status == 404) {
                toast.error(appConstants.CUSTOMER_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                toast.error(CustomerLossHistoryConstant.SAVE_CUSTOMER_LOSS_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    }
    
    //  Defaulting policy number, eff date and exp date only if there is one policy
    useEffect(() => {
    if (listOfPolicy && listOfPolicy.length === 1 &&
        (!customerLossData.policyNumber || !listOfPolicy.some(p => p.value === customerLossData.policyNumber))) {
        let splitData = listOfPolicy[0].value.split(':')[1].split('-');
        setCustomerLossData( {
            ...customerLossData,
            ['policyNumber']: listOfPolicy[0].value, ['policyEffDate']: new Date(splitData[0]), ['policyExpDate']: new Date(splitData[1])
        });
    }
}, [customerLossData]);

    const mainLayout = <>
        {/* <Row>
            <Column lg={columnFullLg} md={columnFullMd} className="">
                <h6 className="new-entry-main-title">ADD {lables.CustomerLossHistoryScreenLables.LOSS_HISOTRY}</h6>
            </Column>
        </Row> */}

        <Row>
            <Column lg={7} md={7}>
                <Row>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <FloatingLabel
                            controlId="company"
                            className="mb-3"
                            label={lables.CustomerLossHistoryScreenLables.company}
                        >
                            <Form.Control
                                autoFocus
                                type="text"
                                name="company"
                                placeholder={lables.CustomerLossHistoryScreenLables.company}
                                value={customerLossData.company}
                                onChange={(event) => onEntityFieldChange('company', event.currentTarget.value)}
                                disabled={!isEditable}
                                ref={companyRef}
                                onKeyDown={(e) => {
                                    if (e.key == "Tab" && e.shiftKey) {
                                        e.preventDefault();
                                    }
                                }}
                                maxLength={30}
                                tabIndex={1}
                            />
                        </FloatingLabel>
                    </Column>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <FloatingLabel
                            controlId="employeeName"
                            className="mb-3"
                            label={lables.CustomerLossHistoryScreenLables.employeeName}
                        >
                            <Form.Control
                                type="text"
                                name="employeeName"
                                placeholder={lables.CustomerLossHistoryScreenLables.employeeName}
                                value={customerLossData.changedByValue}
                                disabled={true}
                                readOnly
                            />
                        </FloatingLabel>
                    </Column>
                </Row>
                <Row>
                    <Column lg={columnFullLg} md={columnFullMd}>
                        <h6 className="cst-lss-section-header">{lables.CustomerLossHistoryScreenLables.lossDetail}</h6>
                    </Column>
                </Row>
                <Row>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <Select
                            id='PolicyNumber'
                            label={lables.CustomerLossHistoryScreenLables.policyNumber}
                            options={listOfPolicy}
                            defaultSelected={listOfPolicy?.filter(({ value }) =>
                                value === customerLossData.policyNumber
                            )}
                            onChange={(value:any) => {
                                onEntityFieldChange('policyNumber', value[0] as string)
                            }}
                            placeholder={CustomerLossHistoryConstant.PLEASE_SELECT}
                            multiple={false}
                            tabIndex={2}
                            //showAsFloatingLabel={false}
                            className='mb-3'
                            isRequired={true}
                            isInvalid={formValidation['policyNumber']?.isValid == false}
                            invalidWarning={formValidation['policyNumber']?.warningText}
                            sortOptions={false}
                        />
                    </Column>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <FloatingLabel
                            controlId="claimNumber"
                            className="mb-3"
                            label={lables.CustomerLossHistoryScreenLables.claimNumber}
                        >
                            <Form.Control
                                type="text"
                                name="claimNumber"
                                placeholder={lables.CustomerLossHistoryScreenLables.claimNumber}
                                value={customerLossData.claimNo}
                                onChange={(event) => onEntityFieldChange('claimNo', event.currentTarget.value)}
                                disabled={!isEditable}
                                maxLength={36}
                                tabIndex={3}
                            />
                        </FloatingLabel>
                    </Column>
                </Row>
                <Row>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <Select
                            id='ddKindOfLoss'
                            label={lables.CustomerLossHistoryScreenLables.kindOfLoss}
                            options={lossTypesList}
                            defaultSelected={lossTypesList?.filter(({ value }) =>
                                value === customerLossData.lossType
                            )}
                            onChange={(values) => {
                                onEntityFieldChange('lossType', values[0] as string)
                            }}
                            placeholder={CustomerLossHistoryConstant.PLEASE_SELECT}
                            multiple={false}
                            tabIndex={5}
                            showAsFloatingLabel={true}
                            className='mb-3'
                        />
                    </Column>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>
                                {lables.CustomerLossHistoryScreenLables.dateOfLoss}
                            </InputGroup.Text>
                            <DatePicker
                                dateFormatCalendar="LLLL yyyy"
                                dropdownMode="scroll"
                                selected={CommonUtility.datetimeToDateOnlyObject(customerLossData.dateOfLoss)}
                                tabIndex={6}
                                onChange={(date) => onEntityFieldChange('dateOfLoss', date)}
                                className="form-control"
                            />
                            <InputGroup.Text>
                                <i className="bi bi-calendar3"></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Column>
                </Row>
                <Row>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>
                                {lables.CustomerLossHistoryScreenLables.effectiveDate}
                            </InputGroup.Text>
                            <DatePicker
                                dateFormatCalendar="LLLL yyyy"
                                dropdownMode="scroll"
                                selected={CommonUtility.datetimeToDateOnlyObject(customerLossData.policyEffDate)}
                                tabIndex={7}
                                onChange={(date) => onEntityFieldChange('policyEffDate', date)}
                                className="form-control"
                                disabled={true }
                            />
                            <InputGroup.Text>
                                <i className="bi bi-calendar3"></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Column>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>
                                {lables.CustomerLossHistoryScreenLables.dateReported}
                            </InputGroup.Text>
                            <DatePicker
                                dateFormatCalendar="LLLL yyyy"
                                dropdownMode="scroll"
                                selected={CommonUtility.datetimeToDateOnlyObject(customerLossData.reportDate)}
                                tabIndex={8}
                                onChange={(date) => onEntityFieldChange('reportDate', date)}
                                className="form-control"
                            />
                            <InputGroup.Text>
                                <i className="bi bi-calendar3"></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Column>
                </Row>
                <Row>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>
                                {lables.CustomerLossHistoryScreenLables.expirationDate}
                            </InputGroup.Text>
                            <DatePicker
                                dateFormatCalendar="LLLL yyyy"
                                dropdownMode="scroll"
                                selected={CommonUtility.datetimeToDateOnlyObject(customerLossData.policyExpDate)}
                                tabIndex={9}
                                onChange={(date) => onEntityFieldChange('policyExpDate', date)}
                                className="form-control"
                                disabled={true }
                            />
                            <InputGroup.Text>
                                <i className="bi bi-calendar3"></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Column>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <FloatingLabel
                            controlId="amountToPay"
                            label={lables.CustomerLossHistoryScreenLables.amountToPay}
                        >
                            <Form.Control
                                type="number"
                                name="amountToBePaid"
                                placeholder={lables.CustomerLossHistoryScreenLables.amountToPay}
                                value={customerLossData.amountPaid?.toString()}
                                onChange={(event) => onEntityFieldChange('amountPaid', event.currentTarget.value)}
                                disabled={!isEditable}
                                tabIndex={10}
                            />
                        </FloatingLabel>
                    </Column>
                </Row>
                <Row>

                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <Select
                            id='claimStatus'
                            label={lables.CustomerLossHistoryScreenLables.claimStatus}
                            options={claimStatusList}
                            defaultSelected={claimStatusList?.filter(({ value }) =>
                                value === customerLossData.claimStatusId
                            )}
                            onChange={(values) => {
                                onEntityFieldChange('claimStatusId', values[0] as string)
                            }}
                            placeholder={CustomerLossHistoryConstant.PLEASE_SELECT}
                            multiple={false}
                            tabIndex={11}
                            showAsFloatingLabel={true}
                            className='mb-3'
                        />
                    </Column>
                    <Column lg={defaultColumnLg} md={defaultColumnMd}>
                        <InputGroup>
                            <InputGroup.Text>
                                {lables.CustomerLossHistoryScreenLables.closeDate}
                            </InputGroup.Text>
                            <DatePicker
                                dateFormatCalendar="LLLL yyyy"
                                dropdownMode="scroll"
                                selected={CommonUtility.datetimeToDateOnlyObject(customerLossData.closedDate)}
                                tabIndex={12}
                                onChange={(date) => onEntityFieldChange('closedDate', date)}
                                className="form-control"
                            />
                            <InputGroup.Text>
                                <i className="bi bi-calendar3"></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Column>
                </Row>
                <Row>


                </Row>
            </Column>
            <Column lg={5} md={5}>

                <FloatingLabel
                    className="h-100 pb-3"
                    controlId="lossDescription"
                    label={lables.CustomerLossHistoryScreenLables.description}
                >
                    <Form.Control
                        as="textarea"
                        name="lossDescription"
                        placeholder={lables.CustomerLossHistoryScreenLables.description}
                        value={customerLossData.lossDescription}
                        onChange={(event) => onEntityFieldChange('lossDescription', event.currentTarget.value)}
                        disabled={!isEditable}
                        tabIndex={4}
                        maxLength={765}
                        className='texbox-input'
                        style={{ height: '100%' }}
                    />
                </FloatingLabel>

            </Column>
        </Row>

        {/* Action Row */}
        <Row className="mb-2">
            <Column lg={10} md={10}>
                <Button
                    className='btn btn-outline-tertiary  action-btn-base'
                    key="btnLossHistoryCancel"
                    onClick={() => onCancelClick()}
                    id="btnLossHistoryCancel"
                    color='primary'
                    outlined={true}
                    tabIndex={13}
                >{lables.CANCEL.toLocaleUpperCase()}
                </Button>

            </Column>
            <Column lg={2} md={2} className="text-right">
                <Button
                    className='btn btn-primary action-btn-base'
                    key="btnLossHistorySave"
                    onClick={() => onSaveClick()}
                    tabIndex={14}
                    id="btnLossHistorySave"
                    color='primary'
                    keyDown={(e) => {
                        if (e.key == "Tab" && !e.shiftKey) {
                            companyRef.current.focus();
                            e.preventDefault();
                        }
                    }}
                    disabled={customerLossData.id ? !canUserEditCustomerLossHistory : !canUserCreateCustomerLossHistory}
                >{lables.SAVE.toLocaleUpperCase()}
                </Button>
            </Column>
        </Row>
    </>;

    return <div className="main-cst-lss-div">
        {mainLayout}
    </div>;
}

export default CustomerLossForm;